/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Renew_PlusInputs */

const en_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renew Plus`)
};

const ar_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جدّد اشتراك Plus`)
};

const de_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus verlängern`)
};

const es_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renovar Plus`)
};

const fr_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renouveler Plus`)
};

const it_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rinnova Plus`)
};

const ja_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusを更新`)
};

const ko_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 갱신`)
};

const pt_br_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renovar o Plus`)
};

const ru_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продлить Plus`)
};

const th_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต่ออายุ Plus`)
};

const tr_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus'ı yenile`)
};

const zh_cn_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`续订 Plus`)
};

const zh_tw_btn_renew_plus = /** @type {(inputs: Btn_Renew_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`續訂 Plus`)
};

/**
* | output |
* | --- |
* | "Renew Plus" |
*
* @param {Btn_Renew_PlusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_renew_plus = /** @type {((inputs?: Btn_Renew_PlusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Renew_PlusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_renew_plus(inputs)
	if (locale === "ar") return ar_btn_renew_plus(inputs)
	if (locale === "de") return de_btn_renew_plus(inputs)
	if (locale === "es") return es_btn_renew_plus(inputs)
	if (locale === "fr") return fr_btn_renew_plus(inputs)
	if (locale === "it") return it_btn_renew_plus(inputs)
	if (locale === "ja") return ja_btn_renew_plus(inputs)
	if (locale === "ko") return ko_btn_renew_plus(inputs)
	if (locale === "pt_br") return pt_br_btn_renew_plus(inputs)
	if (locale === "ru") return ru_btn_renew_plus(inputs)
	if (locale === "th") return th_btn_renew_plus(inputs)
	if (locale === "tr") return tr_btn_renew_plus(inputs)
	if (locale === "zh_cn") return zh_cn_btn_renew_plus(inputs)
	return zh_tw_btn_renew_plus(inputs)
});